/**
 * Ryan O'Dowd
 * 2024-08-06
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({fonts, globalScale, colors}) => {
  return {
    searchHistoryHeaderText: {
      fontSize: 14,
    },
    superSearchHistoryRow: {
      display: 'flex',
      flexDirection: 'row',
      flex: 1,
      width: '100%',
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
    superSearchHistoryListItem: {
      flexGrow: 1,
    },
    superSearchHistoryText: {
      flex: 1,
      fontSize: globalScale * 16,
      color: colors.white,
      fontFamily: fonts.secondaryBold,
    },
    removeButton: {
      marginLeft: 0,
      marginTop: 0,
      marginBottom: 0,
    },
  };
};

export default getStyles;
